import React, { FC } from 'react';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../store/merchnts/merchants-context';

import './ApplicationViewAsideMenu.scss';

export const APPLICATION_VIEW_BASE_VIEW = 'application-view';
export enum APPLICATION_VIEW_STEPS {
  BUSINESS_DETAILS = 'business-details',
  SUMMARY = 'summary',
}

enum STATUSES {
  DRAFT = 'DRAFT',
  CANCELLED = 'CANCELLED',
  SUBMITTED = 'SUBMITTED',
  IN_REVIEW = 'IN_REVIEW',
  APPROVED = 'APPROVED',
  DECLINED = 'DECLINED'
}

const STEPS = [
  {
    key: APPLICATION_VIEW_STEPS.BUSINESS_DETAILS,
    step: 1,
    title: 'SELF_ONBOARDING.BUSINESS_DETAILS',
    status: STATUSES.DRAFT
  },
  {
    key: APPLICATION_VIEW_STEPS.SUMMARY,
    step: 2,
    title: 'SELF_ONBOARDING.SUMMARY',
    status: STATUSES.IN_REVIEW
  }
];

export const ApplicationViewAsideMenu: FC = () => {
  const { t } = useTranslation();

  const { merchantState: { applicationViewData }} = useMerchants();

  const applicantStatus = applicationViewData?.statusName;

  return (
    <div>
      {
        STEPS.map(({ key, title, step, status }) => {
          const isActive = applicantStatus === status;
          const enableIcon = applicantStatus === STATUSES.IN_REVIEW && key === APPLICATION_VIEW_STEPS.BUSINESS_DETAILS
            || applicantStatus === STATUSES.SUBMITTED;
          return (
            <div className="menu-item" key={key}>
              <div className={clsx('without-sub cursor-default self-onboarding-steps' )}>
                <div className={clsx(
                  'me-3 self-onboarding-menu-icon-container',
                  enableIcon && 'active',
                  isActive && 'text-danger'
                )}>
                  {
                    enableIcon
                      ? <FontAwesomeIcon icon={faCheckCircle}/>
                      : step
                  }
                </div>
                <span className={clsx('menu-title self-onboarding-title', isActive ? 'text-danger' : 'text-black')}>{t(title)}</span>
              </div>
            </div>
          );
        })
      }

    </div>
  );
};
